(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-swipe"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('multicolumn-swipe')) {
    class MulticolumnSwipe extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.items = Array.from(this.track.children);
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));

        this.prev?.addEventListener('click', () => this.step(-1));
        this.next?.addEventListener('click', () => this.step(1));
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot)))
        );

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        this.setupAutoplay();
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
        clearInterval(this.timer);
      }

      itemWidth() {
        if (this.items.length < 2) return this.track.clientWidth;
        return this.items[1].offsetLeft - this.items[0].offsetLeft;
      }

      maxIndex() {
        const w = this.itemWidth();
        if (!w) return 0;
        const max = Math.round((this.track.scrollWidth - this.track.clientWidth) / w);
        return Math.max(0, max);
      }

      currentIndex() {
        const w = this.itemWidth();
        return w ? Math.round(this.track.scrollLeft / w) : 0;
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.maxIndex()));
        this.track.scrollTo({ left: clamped * this.itemWidth() });
      }

      step(dir) {
        const max = this.maxIndex();
        let target = this.currentIndex() + dir;
        if (this.dataset.autoplay === 'true') {
          if (target > max) target = 0;
          if (target < 0) target = max;
        }
        this.goTo(target);
      }

      update() {
        const index = this.currentIndex();
        const max = this.maxIndex();
        const loop = this.dataset.autoplay === 'true';
        if (this.prev) this.prev.disabled = !loop && index <= 0;
        if (this.next) this.next.disabled = !loop && index >= max;
        this.dots.forEach((dot, i) => {
          dot.hidden = i > max;
          dot.setAttribute('aria-current', i === Math.min(index, max) ? 'true' : 'false');
        });
        const controls = this.querySelector('.mcs__controls');
        if (controls) controls.style.display = max === 0 ? 'none' : '';
      }

      setupAutoplay() {
        if (this.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const speed = Number(this.dataset.speed) || 5000;
        const start = () => {
          clearInterval(this.timer);
          this.timer = setInterval(() => this.step(1), speed);
        };
        const stop = () => clearInterval(this.timer);
        this.addEventListener('mouseenter', stop);
        this.addEventListener('mouseleave', start);
        this.addEventListener('focusin', stop);
        this.addEventListener('focusout', start);
        this.track.addEventListener('touchstart', stop, { passive: true });
        this.track.addEventListener('touchend', start, { passive: true });
        start();
      }
    }
    customElements.define('multicolumn-swipe', MulticolumnSwipe);
  }

  } catch(e) { console.error(e); }
})();
})();
